// Core
import { 
  Route, 
  Switch, 
  Redirect, 
  useRouteMatch, 
} from 'react-router-dom';

// Chakra imports
import { 
  Box,
} from '@chakra-ui/react';

// Components
import RequestLog from './RequestLog';
import RequestLogDetails from './RequestLogDetails';

function RequestLogs(props) {
  const { path } = useRouteMatch();

  return (
    <>
      <Box>
        <Switch>
          <Route path={`${path}/:id`} render={() => <RequestLogDetails/>}/>
          <Route path={`${path}`} render={() => <RequestLog/>}/>
          <Redirect from={`${path}*`} to={`${path}`} />
        </Switch>
      </Box>
    </>
  );
}

export default RequestLogs;